import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'
import { Post } from '../models/Post'

interface PostListResponse extends HttpResponse {
  data: Post[]
}

interface PostResponse extends HttpResponse {
  data: Post
}

const Posts = {
  list: () => requests.get<PostListResponse>('/Post'),
  listForHomePage: () => requests.get<PostListResponse>('/Post/homepage'),
  listMyPosts: () => requests.get<PostListResponse>('/Post/my'),
  details: (id: string) => requests.get<PostResponse>(`/Post/${id}`),
  create: (formData: FormData) =>
    requests.post<PostResponse>('/Post', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  update: (postId: string, formData: FormData) =>
    requests.put<PostResponse>(`/Post/${postId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  delete: (id: string) => requests.del<void>(`/Post/${id}`),
}

export default Posts
